import React, { useEffect, useState } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import LightModeIcon from '@mui/icons-material/LightMode'
import { Link, useParams } from 'react-router'
import DeviceLogsContent from '../components/DeviceLogsContent'
import cnergiLogo from '../resources/CNERGI_PNG@4x.png'
import {
  getLoginSession,
  getProfileDeviceIds,
  getUserProfile,
} from '../services/authApi'
import './MobileDashboardPage.css'
import './MobileDashboardLogsPage.css'

function MobileDashboardLogsPage({ isDarkMode = false, onToggleTheme }) {
  const { deviceId: routeDeviceId = '' } = useParams()
  const [deviceId, setDeviceId] = useState(routeDeviceId)
  const dashboardPath = deviceId ? `/mobile/dashboard/${encodeURIComponent(deviceId)}` : '/mobile/dashboard'

  useEffect(() => {
    let isMounted = true
    const loginSession = getLoginSession()

    if (routeDeviceId) {
      setDeviceId(routeDeviceId)
      return () => {
        isMounted = false
      }
    }

    if (!loginSession?.user?.email) {
      setDeviceId('')
      return () => {
        isMounted = false
      }
    }

    getUserProfile(loginSession.user.email)
      .then((profileResponse) => {
        const [primaryDeviceId = ''] = getProfileDeviceIds(profileResponse)

        if (isMounted) {
          setDeviceId(primaryDeviceId)
        }
      })
      .catch((error) => {
        console.error('Mobile logs profile request failed:', error)

        if (isMounted) {
          setDeviceId('')
        }
      })

    return () => {
      isMounted = false
    }
  }, [routeDeviceId])

  return (
    <main className="mobile-dashboard mobile-dashboard-logs">
      <header className="mobile-dashboard__topbar">
        <Link className="mobile-dashboard__icon-link" to={dashboardPath} aria-label="Back to mobile dashboard">
          <ArrowBackIcon aria-hidden="true" />
        </Link>

        <Link className="mobile-dashboard__brand" to="/" aria-label="CNERGI home">
          <img src={cnergiLogo} alt="CNERGI" />
        </Link>

        <button
          className="mobile-dashboard__icon-button"
          type="button"
          aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={onToggleTheme}
        >
          {isDarkMode ? <LightModeIcon aria-hidden="true" /> : <DarkModeIcon aria-hidden="true" />}
        </button>
      </header>

      <section className="mobile-dashboard__summary" aria-labelledby="mobile-logs-title">
        <p>Device Logs</p>
        <h1 id="mobile-logs-title">{deviceId || 'No device selected'}</h1>
        <span>Review import and export history by range.</span>
      </section>

      <section className="mobile-dashboard-logs__panel" aria-label="Device logs">
        <DeviceLogsContent deviceId={deviceId} />
      </section>
    </main>
  )
}

export default MobileDashboardLogsPage
